import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { OAuthCallback } from './pages/OAuthCallback';
import { AccessDenied } from './pages/AccessDenied';
import { Dashboard } from './pages/Dashboard';
import { Tenants } from './pages/Tenants';
import { TenantDetails } from './pages/TenantDetails';
import { ServiceTokens } from './pages/ServiceTokens';
import { TaxRates } from './pages/TaxRates';
import { Invoices } from './pages/Invoices';
import { Settlement } from './pages/Settlement';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/tenants/:id"
            element={
              <ProtectedRoute>
                <TenantDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/tenants"
            element={
              <ProtectedRoute>
                <Tenants />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/service-tokens"
            element={
              <ProtectedRoute>
                <ServiceTokens />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/tax-rates"
            element={
              <ProtectedRoute>
                <TaxRates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/invoices"
            element={
              <ProtectedRoute>
                <Invoices />
              </ProtectedRoute>
            }
          />
          {/* Public Settlement Page - No authentication required */}
          <Route path="/settlement/:invoiceId" element={<Settlement />} />
          {/* PayPal return URL - uses the same component */}
          <Route path="/settlement/:invoiceId/paypal-return" element={<Settlement />} />
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
